import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@metarouter-private/mr-mui';

export default function IntegrationActivationModalContent({ integrationName, shouldDisable }) {
  return (
    <Typography variant="body1" color="text.secondary">
      Set{' '}
      <Typography fontWeight="700" component="span">
        {integrationName}{' '}
      </Typography>
      to be {shouldDisable ? 'paused' : 'activated'} following the next deployment?
    </Typography>
  );
}

IntegrationActivationModalContent.propTypes = {
  integrationName: PropTypes.string,
  shouldDisable: PropTypes.bool,
};
